<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('INDEX.shipment_doc_label_search') ||
                  '上传人/文件名/发运节点/发运文档类型...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
                <b-button-group class="ml-2" size="sm">
                  <b-button
                    variant="outline-success"
                    @click="$emit('openUploadFormDialog')"
                    :disabled="disabled"
                  >
                    <i class="el-icon-plus" />
                    {{ $l('INDEX.btn_upload') || '上传' }}
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant="outline-danger"
                    @click="$emit('batchDel')"
                    :disabled="disabled"
                  >
                    <i class="el-icon-delete"></i>
                    {{ $l('INDEX.btn_delete') || '删除' }}
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_doc_uploadByName') || '上传人姓名'"
            >
              <el-input
                v-model.trim="form.uploadByName"
                :placeholder="
                  $l('INDEX.form_placeholder_uploadByName') ||
                    '请输入上传人姓名'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_fileName') || '文档名称'">
              <el-input
                v-model.trim="form.fileName"
                :placeholder="
                  $l('INDEX.form_placeholder_fileName') || '请输入文档名称'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_shipmentNode') || '发运节点'">
              <dict-select
                v-model="form.listShipmentNode"
                :body="shipmentNodeParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('INDEX.form_placeholder_shipmentNode') || '请选择发运节点'
                "
                size="small"
                clearable
                multiple
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_shipmentDocFileType') || '发运单文档类型'"
            >
              <dict-select
                v-model="form.listShipmentDocFileType"
                :body="shipmentDocFileTypeParams"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('INDEX.form_placeholder_shipmentDocFileType') ||
                    '请选择发运单文档类型'
                "
                size="small"
                clearable
                multiple
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('INDEX.order_doc_uploadTime') || '上传时间'"
                label-width="100px"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.uploadStartTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="uploadStartTimeOptions"
                    :placeholder="$l('INDEX.tips_select_time') || '请选择时间'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.uploadEndTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="uploadEndTimeOptions"
                    :placeholder="$l('INDEX.tips_select_time') || '请选择时间'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      shipmentNodeParams: { dictType: 'shipmentNode' },
      shipmentDocFileTypeParams: { dictType: 'shipmentDocFileType' },
      uploadStartTimeOptions: (time) => {
        if (this.form.operationEndTime) {
          return new Date(this.form.operationEndTime).getTime() < time.getTime()
        }
      },
      uploadEndTimeOptions: (time) => {
        if (this.form.operationStartTime) {
          return (
            new Date(this.form.operationStartTime).getTime() -
              3600 * 1000 * 24 >
            time.getTime()
          )
        }
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
